import React from 'react';
import { Accessibility, AlertTriangle } from 'lucide-react';

interface CategoryItem {
  id: string;
  label: string;
  icon: any;
  score?: number;
}

interface ImprovementSidebarProps {
  categories: CategoryItem[];
  selectedId: string;
  onSelect: (id: string) => void;
}

export function ImprovementSidebar({ categories, selectedId, onSelect }: ImprovementSidebarProps) {
  return (
    <div className="w-64 border-r bg-white shadow-sm flex-shrink-0">
      <div className="px-4 py-4 text-m font-semibold text-foreground border-b border-border bg-gradient-to-r from-muted/50 to-muted/30">
        <div className="flex items-center gap-2">
          <Accessibility className="w-4 h-4 text-primary" />
          Categorie di accessibilità
        </div>
      </div>
      <div className="pt-2">
        <nav className="space-y-1">
          {categories.map((category) => {
            const needsAttention = category.score && category.score < 95;
            const Icon = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => onSelect(category.id)}
                className={`cursor-pointer flex items-center justify-between w-full px-4 py-3 hover:bg-muted/50 transition-colors duration-200 ${selectedId === category.id
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground'
                  }`}
              >
                <div className="flex items-center gap-3">
                  <Icon className="w-4 h-4 flex-shrink-0" />
                  <span className="text-s font-medium">{category.label}</span>
                </div>
                <div className="flex items-center gap-2">
                  {needsAttention && (
                    <AlertTriangle className="w-4 h-4 text-red-500" />
                  )}
                  {category.score != null && (
                    <span className={`text-ss px-2 py-1 rounded-full font-medium ${category.score < 95
                        ? 'bg-red-100 text-red-600 border border-red-200'
                        : 'bg-green-100 text-green-600 border border-green-200'
                      }`}>
                      {category.score}%
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
